import { Fragment } from 'react';

import useMeetTeamEntry from './UseMeetTeamEntry';

import MeetTeamEntryGrid from './MeetTeamEntryGrid';

import DeleteOmeModalInfo from '../../myMeets/meetHost/DeleteOmeModalInfo';

import OmeMeetEntryInfoDropdown from '../../../components/dropdowns/OmeMeetEntryInfoDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const MeetTeamEntry = () => {
  const { state, omeMeetTeamEntryStatusState, omeMeetState, omeMeetOrgUnitEntryState, omeMeetOrgUnitEntryInfoState, omeMeetTeamEntryState, personOrgRoleState, onAddEntryClicked, onEditTeamEntry, onEnterMeetClicked,
    onStartEntryForATeamClicked, onDeleteTeamEntryClicked, onDeleteTeamEntry, onViewTeamEntry, onModalCanceled, modalState, formState, errorState, onValueTextPairChanged, onFormValueChanged, onFilterClicked, onClearFilterClicked } = useMeetTeamEntry();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Team Entry Management</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className='col-xs-12'>
          {omeMeetState?.objData?.omeMeetId ?
            <Fragment>
              {omeMeetTeamEntryState?.objData?.teamEntryCurrentlyAllowed === false && omeMeetState?.objData?.status === Constants.WORKFLOW_STATUS_IN_PROGRESS && <p className={global.HeaderText}><b>Online Meet Entry is not fully set up for this meet. Starting a new Team Entry is currently not allowed.</b></p>}
              {omeMeetTeamEntryState?.objData?.teamEntryCurrentlyAllowed === false && omeMeetState?.objData?.status !== Constants.WORKFLOW_STATUS_IN_PROGRESS && <p className={global.HeaderText}><b>Online Meet Entry is not open at this time. Starting a new Team Entry is currently not allowed.</b></p>}
            </Fragment> :
            <p className={global.HeaderText}><b>Online Meet Entry is not set up for this meet. Starting a new Team Entry is currently not allowed.</b></p>}
          {omeMeetState?.objData?.omeMeetId && omeMeetState?.objData?.status === Constants.WORKFLOW_STATUS_CREATED && personOrgRoleState.isArrayLoading === false && omeMeetOrgUnitEntryState.isArrayLoading === false &&
            omeMeetTeamEntryState?.objData?.teamEntryCurrentlyAllowed === true &&
            ((omeMeetTeamEntryState.objData?.teamEntry?.length === 0 || omeMeetTeamEntryState.objData?.teamEntry === null) && (formState.omeMeetEntryId === Constants.DEFAULT_ID && formState.teamEntryStatusId === Constants.DEFAULT_ID) && state.availableOrgUnits.length === 0) &&
            <p className={global.HeaderText}><b>The Logged In User is Not Associated with any Organizations that are Invited to the Meet.</b></p>}
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className='col-xs-12 usas-extra-top-margin'>
          {omeMeetState?.objData?.omeMeetId && omeMeetState?.objData?.status === Constants.WORKFLOW_STATUS_CREATED &&
            omeMeetTeamEntryState?.objData?.teamEntryCurrentlyAllowed === true && state.availableOrgUnits.length > 0 &&
            <span><ActionIntraPageButton onClick={(e) => onEnterMeetClicked(e)}>Enter Meet</ActionIntraPageButton>&nbsp;</span>}
          {omeMeetState?.objData?.omeMeetId && omeMeetState?.objData?.status === Constants.WORKFLOW_STATUS_CREATED &&
            omeMeetTeamEntryState?.objData?.teamEntryCurrentlyAllowed === true &&
            <ActionIntraPageButton onClick={(e) => onStartEntryForATeamClicked(e)}>Start Entry For a Team</ActionIntraPageButton>}
        </div>
        {omeMeetState?.objData?.omeMeetId &&
          <form>
            <div className='col-xs-12 col-sm-8 col-md-6 usas-extra-top-margin usas-extra-bottom-margin'>
              <OmeMeetEntryInfoDropdown
                label="OME Meet"
                name="omeMeetEntryId"
                value={formState.omeMeetEntryId}
                error={errorState.omeMeetEntryId}
                message={errorState.omeMeetEntryId}
                onChange={(value, newValueLabel, e) => {
                  e && e.target && e.target.value &&
                    onValueTextPairChanged(value, 'omeMeetEntryId', newValueLabel, 'omeMeetEntryName');
                }}
                omeMeetId={omeMeetState.objData?.omeMeetId}
                isCurrent={false}
              />
            </div>
            <div className='col-xs-12 col-sm-4 col-md-3 usas-extra-top-margin usas-extra-bottom-margin'>
              <Dropdown
                label="Team Entry Status"
                name="teamEntryStatusId"
                options={omeMeetTeamEntryStatusState}
                value={formState.teamEntryStatusId}
                error={errorState.teamEntryStatusId}
                message={errorState.teamEntryStatusId}
                isLoading={false}
                onChange={(value) => { onFormValueChanged('teamEntryStatusId', value); }} />
            </div>
            <div className='col-xs-6 col-sm-2 col-md-1 usas-extra-top-margin usas-extra-bottom-margin'>
              <button className={global.PlainButton} onClick={(e) => onFilterClicked(e)}>Filter</button>
            </div>
            <div className='col-xs-6 col-sm-4 col-md-2 usas-extra-top-margin usas-extra-bottom-margin'>
              <button className={global.PlainButton} onClick={(e) => onClearFilterClicked(e)}>Clear Filter</button>
            </div>
          </form>}
        <div className='col-xs-12'>
          <MeetTeamEntryGrid
            gridData={omeMeetTeamEntryState.objData?.teamEntry || []}
            isLoading={omeMeetTeamEntryState.isObjLoading}
            onAddEntryClicked={onAddEntryClicked}
            onView={onViewTeamEntry}
            onEdit={onEditTeamEntry}
            onDeleteTeamEntryClicked={onDeleteTeamEntryClicked}
          />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={modalState.modalTitle}
        displayPopUp={modalState.displayPopUp}
        onModalCanceled={onModalCanceled}>
        <div className="row">
          <div className='col-xs-12'>
            <DeleteOmeModalInfo modalState={modalState} />
            <p><strong>OME Meet Name:</strong> {modalState?.omeMeetName}</p>
            <p><strong>Entry Start - End Dates:</strong> {modalState?.omeMeetEntryDates}</p>
            <p><strong>Time Zone:</strong> {modalState?.timeZone}</p>
            <p><strong>Team Name:</strong> {modalState?.teamName}</p>
            <p><strong>Team Entry Status:</strong> {modalState?.teamEntryStatus}</p>
          </div>
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={(e) => onDeleteTeamEntry(e, modalState.omeMeetId, modalState.omeMeetEntryId, modalState.omeMeetOrgUnitEntryId)}>Delete</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={30}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={omeMeetState.isArrayLoading || personOrgRoleState.isArrayLoading || omeMeetOrgUnitEntryState.isObjLoading
          || omeMeetOrgUnitEntryInfoState.isObjLoading || omeMeetTeamEntryState.isObjLoading} />
      <PopUpModal
        widthPct={30}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={omeMeetOrgUnitEntryState.isSaving} />
    </Fragment>);
}

export default MeetTeamEntry;